import { render, staticRenderFns } from "./IntroComponent.vue?vue&type=template&id=1c4e6836&"
import script from "./IntroComponent.vue?vue&type=script&lang=ts&"
export * from "./IntroComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports